/**
 * Mock data for local development
 * Used when running on localhost to simulate Telegram Mini App environment
 */

// Different test users for development
export const MOCK_USERS = {
  user1: {
    id: 123456789,
    first_name: "Тест",
    last_name: "Пользователь",
    username: "test_user",
    language_code: "ru"
  },
  user2: {
    id: 987654321,
    first_name: "Test",
    last_name: "User",
    username: "test_user_en",
    language_code: "en"
  },
  user3: {
    id: 555666777,
    first_name: "Игрок",
    last_name: "Три",
    username: "player3",
    language_code: "ru"
  }
}

// Default user for development (you can change this to test different users)
export const DEFAULT_MOCK_USER = MOCK_USERS.user1

/**
 * Generate mock initData string for API requests
 */
export const generateMockInitData = (user = DEFAULT_MOCK_USER) => {
  const mockData = {
    user,
    hash: "fakehash123",
    auth_date: Math.floor(Date.now() / 1000),
    query_id: "test_query_id"
  }
  
  const params = new URLSearchParams()
  params.append('user', JSON.stringify(mockData.user))
  params.append('hash', mockData.hash)
  params.append('auth_date', mockData.auth_date.toString())
  params.append('query_id', mockData.query_id)
  
  return params.toString()
}

/**
 * Check if running in development mode
 */
export const isDevelopmentMode = () => {
  return window.location.hostname === 'localhost' || 
         window.location.hostname === '127.0.0.1' ||
         window.location.hostname.includes('192.168.') ||
         window.location.hostname.includes('10.0.') ||
         process.env.NODE_ENV === 'development'
}

/**
 * Mock Telegram WebApp object for development
 */
export const createMockTelegramWebApp = (user = DEFAULT_MOCK_USER) => {
  return {
    initData: generateMockInitData(user),
    initDataUnsafe: {
      user,
      hash: "fakehash123",
      auth_date: Math.floor(Date.now() / 1000),
      query_id: "test_query_id"
    },
    version: "6.0",
    platform: "web",
    colorScheme: "dark",
    themeParams: {
      bg_color: "#0A0A0F",
      text_color: "#FFFFFF",
      hint_color: "#999999",
      link_color: "#00FF7F",
      button_color: "#00FF7F",
      button_text_color: "#0A0A0F"
    },
    isExpanded: true,
    viewportHeight: 600,
    viewportStableHeight: 600,
    headerColor: "#0A0A0F",
    backgroundColor: "#0A0A0F",
    expand: () => console.log('📱 Mock: WebApp expanded'),
    close: () => console.log('📱 Mock: WebApp closed'),
    setHeaderColor: (color) => console.log(`📱 Mock: Header color set to ${color}`),
    setBackgroundColor: (color) => console.log(`📱 Mock: Background color set to ${color}`),
    showAlert: (message) => alert(`Telegram Alert: ${message}`),
    showConfirm: (message) => confirm(`Telegram Confirm: ${message}`),
    showPopup: (params) => console.log('📱 Mock: Popup shown', params),
    ready: () => console.log('📱 Mock: WebApp ready'),
    sendData: (data) => console.log('📱 Mock: Data sent', data)
  }
}
